// Product boundary for Ampli Obras only. Director uses separate clients/state.
export const WORKS_RECEIVABLE_FIELDS = Object.freeze([
  "toReceiveBills",
  "receivedBills",
  "firstBillToReceive",
  "firstBillReceived",
  "lastBillToReceiveDateResponse",
  "lastBillReceiveDateResponse",
  "initialBalance",
  "initialBalanceSource",
  "allVariations",
  "allBalances",
  "cashLedgerEntries",
]);
export const WORKS_RECEIVABLE_SERIES = Object.freeze([
  "received",
  "toReceive",
  "allBills",
  "allBillsAccumulated",
  "variation",
  "allBalance",
]);
export const WORKS_REPORT_COLLECTIONS = Object.freeze([
  "disbursements",
  "physical_financials",
  "ampli_disbursements",
  "paid_values",
  "to_pay_values",
  "advancements",
]);
const exportKeys = new Set([
  ...WORKS_RECEIVABLE_FIELDS,
  ...WORKS_RECEIVABLE_SERIES,
  "allBillsRaw",
]);
const payloadKeys = new Set(WORKS_RECEIVABLE_FIELDS);
export const stripWorksReceivables = (value) => {
  if (!value || typeof value !== "object" || Array.isArray(value)) return value;
  const keys = Object.keys(value);
  const allowedKeys = keys.filter((key) => !payloadKeys.has(key));
  const restrictAccess =
    value.access && value.access.receivables !== "restricted";
  if (allowedKeys.length === keys.length && !restrictAccess) return value;
  return {
    ...Object.fromEntries(allowedKeys.map((key) => [key, value[key]])),
    ...(restrictAccess
      ? { access: { ...value.access, receivables: "restricted" } }
      : {}),
  };
};
export const filterWorksSeries = (series = []) => {
  const items = Array.isArray(series) ? series : [];
  const allowed = items.filter((key) => !WORKS_RECEIVABLE_SERIES.includes(key));
  return allowed.length === items.length ? items : allowed;
};
export const stripWorksExport = ({ fields = [], resources = [] } = {}) => ({
  fields: (Array.isArray(fields) ? fields : []).filter(
    ({ key }) => !exportKeys.has(key),
  ),
  resources: (Array.isArray(resources) ? resources : []).map((row) =>
    Object.fromEntries(
      Object.keys(row)
        .filter((key) => !exportKeys.has(key))
        .map((key) => [key, row[key]]),
    ),
  ),
});
export const sanitizeWorksState = (state) => {
  const activeProject = stripWorksReceivables(state.activeProject);
  const graphData = stripWorksReceivables(state.graphData);
  const hasReceivableExport =
    state.xlsxData &&
    (state.xlsxData.fields?.some((field) => exportKeys.has(field.key)) ||
      state.xlsxData.resources?.some((row) =>
        Object.keys(row).some((key) => exportKeys.has(key)),
      ));
  const xlsxData = hasReceivableExport
    ? stripWorksExport(state.xlsxData)
    : state.xlsxData;
  if (
    activeProject === state.activeProject &&
    graphData === state.graphData &&
    xlsxData === state.xlsxData
  )
    return state;
  return {
    ...state,
    ...(Object.hasOwn(state, "activeProject") ? { activeProject } : {}),
    ...(Object.hasOwn(state, "graphData") ? { graphData } : {}),
    ...(Object.hasOwn(state, "xlsxData") ? { xlsxData } : {}),
  };
};
